import { ca } from '@cian/analytics';

import { ESpecialTabs } from '../../constants/specialTabs';
import { EPageKind } from '../../types/page';
import { FDealType } from '../../utils/category';
import { getEventCategoryFromPageKind } from '../../utils/tracking';

const MORTGAGE_TAB_TRAP_EXTRA = {
  trap_type: 'cigar_mortgage',
  bannerName: 'Ипотека',
  trapid: 'Ипотека',
} as const;

const getMortgageTabTrapPage = () => ({
  extra: MORTGAGE_TAB_TRAP_EXTRA,
});

export function trackMortgageTabShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'show_sopr',
    label: 'mortgage_widget',
    page: getMortgageTabTrapPage(),
  });
}

export function trackDealTypeTabClick(pageKind: EPageKind, type: FDealType) {
  const TAB_NAME_MAP = {
    [FDealType.Sale]: 'sale',
    [FDealType.RentLongterm]: 'rent',
    [FDealType.RentDaily]: 'daily',
  };

  ca('eventSite', {
    category: getEventCategoryFromPageKind(pageKind),
    action: 'Click',
    label: `Tab/${TAB_NAME_MAP[type as keyof typeof TAB_NAME_MAP] || 'unexpected'}`,
  });
}

export function trackSpecialTabClick(pageKind: EPageKind, type: ESpecialTabs) {
  if (type === ESpecialTabs.Mortgage) {
    ca('eventSite', {
      name: 'oldevent',
      category: 'trap',
      action: 'click_sopr',
      label: 'mortgage_widget',
      page: getMortgageTabTrapPage(),
    });

    return;
  }

  const TAB_NAME_MAP = {
    [ESpecialTabs.SearchRealtors]: 'realtor',
    [ESpecialTabs.Valuation]: 'calculate',
    [ESpecialTabs.AddForm]: 'add_form',
  };

  ca('eventSite', {
    category: getEventCategoryFromPageKind(pageKind),
    action: 'Click',
    label: `Tab/${TAB_NAME_MAP[type] || 'unexpected'}`,
  });
}
